import { render, staticRenderFns } from "./ProuniStart.vue?vue&type=template&id=8cb46236&scoped=true&"
import script from "./ProuniStart.vue?vue&type=script&lang=ts&"
export * from "./ProuniStart.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniStart.vue?vue&type=style&index=0&id=8cb46236&scoped=true&lang=scss&"
import style1 from "./ProuniStart.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb46236",
  null
  
)

export default component.exports